/* eslint-disable no-loop-func */
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../component/header";
import { BsPlusLg, BsDashLg } from "react-icons/bs";
import { Link } from "react-router-dom";
import { BiPencil } from "react-icons/bi";
import { Button } from "react-bootstrap";
import { BsFillTrash3Fill } from "react-icons/bs";
import "react-multi-carousel/lib/styles.css";
import { STORAGEKEY } from "../../constants";
import { PostSaleCreate } from "../../services/tableQRServices";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementQuantity,
  decrementQuantity,
  placeOrderSuccess,
  addSalesNo,
  deleteCartItem,
  setCart,
  setTotal,
  setIsGSTInclusive,
  setIsServiceCharge,
  setIsGST,
  setTaxValue,
} from "../../redux/cartSlice";
import Recommendation from "./recommendation";
import _ from "lodash";
import { ConfirmationModal } from "./confirmationModal";
import { Spinner } from "react-bootstrap";
import ConfirmModal from "./ConfirmModal";
import useBrandConfig from "../../hooks/useBrandConfig";
import CartItem from "./CartItem";
import { getProducts } from "../../services/supabase/product";
import { sendPosLog } from "../../services/supabase/posLog";
import useSessionTimeout from "../../hooks/useSessionTimeout";
import usePromotion from "../../hooks/usePromotion";
import { CustomizeModal } from "../home/CustomizeModal";
import { roundNumber } from "../../utils/numberUtils";

function Cart() {
  const sessionTimeout = useSessionTimeout();
  const { config } = useBrandConfig();
  const {
    handleConvertPromotionTotal,
    handleConvertPromotionCart,
    handleConvertPromotionCartItem,
    handleConvertPromotionModifierItem,
    handleGroupCart,
  } = usePromotion();

  const { state } = useLocation();
  const cartData = useSelector((state) => state.cart.cart);
  const total = useSelector((state) => state.cart.total);
  const salesNo = useSelector((state) => state.cart.sales_no);
  const { isGST, isGSTInclusive, taxValue, taxList } = useSelector(
    (state) => state.cart
  );
  const serviceChargeList = useSelector((state) => state.app.serviceChargeList);

  const dineOption = localStorage.getItem("selectiDineOption");
  const orderTime = localStorage.getItem("orderTime");
  const [serviceTaxPer, setServiceTaxPer] = useState(0);
  const [serviceTax, setServiceTax] = useState(0);

  let gstInclusive = isGSTInclusive;
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorShow, setIsErrorShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [GSTTaxValue, setGSTTaxValue] = useState(0);
  const [GSTInclusiveTaxValue, setGSTInclusiveTaxValue] = useState(0);
  const [showModalOpen, setShowModalOpen] = useState(false);
  const [showModalData, setShowModalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState({});
  const [supaProducts, setSupaProducts] = useState([]);

  const formatPromotionCartData = handleGroupCart(
    handleConvertPromotionCart(cartData)
  );

  const cartItemsCount = formatPromotionCartData.reduce(
    (acc, item) => acc + item.qty,
    0
  );

  const dispatcher = useDispatch();

  const formatServiceChargeList = useMemo(
    () => (dineOption === "dinein" ? serviceChargeList : []),
    [dineOption, serviceChargeList]
  );

  const isServiceCharge = formatServiceChargeList?.length > 0;

  const totalServiceChange = useMemo(
    () =>
      (formatServiceChargeList?.reduce((a, b) => (a += b?.service_value), 0) ||
        0) / 100,
    [formatServiceChargeList]
  );

  useEffect(() => {
    if (isServiceCharge && dineOption === "dinein") {
      setServiceTaxPer(0.1);
    }
  }, [config, dineOption, isServiceCharge]);

  useEffect(() => {
    if (isGSTInclusive) {
      setGSTInclusiveTaxValue(
        ((total / (taxValue + 100)) * taxValue).toFixed(2)
      );
    }

    if (isGST) {
      setGSTTaxValue(
        ((total + total * totalServiceChange) * (taxValue / 100)).toFixed(2)
      );
    }

    if (isServiceCharge) {
      setGSTTaxValue((total / (taxValue + 100)) * taxValue);
    }

    setServiceTax(total * Number(totalServiceChange));
  }, [
    totalServiceChange,
    taxValue,
    total,
    config,
    isGSTInclusive,
    isGST,
    isServiceCharge,
  ]);
  const navigate = useNavigate();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
    },
  };
  const incrementCounter = (uuid) => {
    const itemInCart = formatPromotionCartData.find(
      (item) => item.uuid === uuid
    );

    dispatcher(
      incrementQuantity(handleConvertPromotionModifierItem(itemInCart))
    );
  };

  const decrementCounter = (uuid) => {
    const itemInCart = formatPromotionCartData.find(
      (item) => item.uuid === uuid
    );
    const firstUuid = itemInCart?.uuidList?.[0];
    const findOriginalItem = cartData.find((item) => item.uuid === firstUuid);

    dispatcher(
      decrementQuantity(
        handleConvertPromotionModifierItem(findOriginalItem, "minus")
      )
    );
  };
  const formatDate = (date) => {
    const result = date.toLocaleString("en-SG", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return result;
  };
  const placeOrder = (id) => {
    const item = formatPromotionCartData.find((item) => item.uuid === id);
    const customDetails = {
      uuid: item.uuid,
      item: item.item,
      addOnValues: item.addOnValues,
      qty: item.qty,
      remarks: item.remarks,
    };

    if (config?.usingCustomizePage) {
      navigate("/customize-dish", {
        state: {
          uuid: item.uuid,
          item: item.item,
          addOnValues: item.addOnValues,
          qty: item.qty,
          isEdit: true,
        },
      });
    } else {
      setShowModalOpen(true);
      setShowModalData(customDetails);
    }
  };

  const handleFormatCartItem = (data) => {
    const newData = { ...data };
    const newDataItem = { ...data.item };
    const newFormatDataItem = {};

    newDataItem.itemmaster_menutypedtls = undefined;
    newDataItem.itemmaster_menutype = undefined;
    newDataItem.itemmaster_menutype_grpdtls = undefined;
    newDataItem.is_emenu_disable = undefined;
    newDataItem.is_soldout = undefined;
    newDataItem.bal_qty = undefined;
    newDataItem.avl_qty = undefined;
    newDataItem.reset_flag = undefined;
    newDataItem.shot_name = undefined;
    newDataItem.start_time = undefined;
    newDataItem.sku_no = undefined;
    newDataItem.upc_no = undefined;
    newDataItem.base_uom = undefined;
    newDataItem.default_price = undefined;
    newDataItem.takeaway_price = undefined;
    newDataItem.item_type = undefined;
    newDataItem.item_type_desc = undefined;
    newDataItem.item_image = undefined;
    newDataItem.is_menu_item = undefined;
    newDataItem.brand_name = undefined;
    newDataItem.gross_wgt_kg = undefined;
    newDataItem.default_cost = undefined;
    newDataItem.markup_per = undefined;
    newDataItem.vendor_code = undefined;
    newDataItem.reorder_qty_level = undefined;
    newDataItem.is_active = undefined;
    newDataItem.is_auto_reorder = undefined;
    newDataItem.is_returnable = undefined;
    newDataItem.is_alcohol = undefined;
    newDataItem.is_tobacco_item = undefined;
    newDataItem.dine_in_price = undefined;
    newDataItem.max_retail_price = undefined;
    newDataItem.is_openprice = undefined;
    newDataItem.is_weightable = undefined;
    newDataItem.course_seq = undefined;
    newDataItem.is_exclude_promo = undefined;
    newDataItem.is_pay_with_giftcard = undefined;
    newDataItem.is_pay_with_points = undefined;
    newDataItem.is_manualdisc = undefined;
    newDataItem.order_qty = undefined;
    newDataItem.is_level_item = undefined;
    newDataItem.printer_details = undefined;
    newDataItem.selling_uom_dtls = undefined;
    newDataItem.is_level_item = undefined;
    newDataItem.level_menu_button_dtls = undefined;
    newDataItem.dummy_price = undefined;
    newDataItem.supabase_item_desc = undefined;

    Object.keys(newDataItem).forEach((key) => {
      if (newDataItem[key] !== undefined) {
        newFormatDataItem[key] = newDataItem[key];
      }
    });

    return {
      ...newData,
      item: newFormatDataItem,
    };
  };

  const paymentpage = async (usingOnlineLink, type) => {
    setIsLoading(true);
    setShowModal(false);

    let salesDetails = [];
    let i = 1;
    handleGroupCart(handleConvertPromotionCart(cartData), true).forEach(
      (cartItem, index) => {
        let price =
          dineOption === "dinein"
            ? cartItem?.item.selling_uom_dtls[0].price_dtls[0].dine_in_price
            : cartItem?.item.selling_uom_dtls[0].price_dtls[0].takeaway_price;
        let parent_sno = i;
        if (cartItem.addOnValues.length) {
          let qty = cartItem.qty;

          cartItem = handleFormatCartItem(cartItem);

          while (qty > 0) {
            let sno = i;
            let parent_sno = i;

            salesDetails.push({
              s_no: sno++,
              ds_no: 1,
              parent_sno,
              seat_no: 1,
              qty: 1,
              uom_cf: 1,
              pro_disc_amt: 0,
              disc_type: "N",
              disc_value: 0,
              ...cartItem?.item,
              disc_amt: 0,
              disc_name: cartItem?.item?.promo_name || "",
              unit_price: 0,
              price: 0,
              sub_total: 0,
              svc_amt: 0,
              is_apply_svc: 1,
              tax_amt: 0,
              tax_rate: cartItem?.item?.is_absorbtax,
              tax_value: cartItem?.item?.tax_value,
              is_absorbtax: cartItem?.item?.is_absorbtax,
              take_away_item: dineOption === "dinein" ? "N" : "Y",
              order_seq: 1,
              order_seq_type: "New",
              order_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
              print_flag: "N",
              item_kds_ready_status: "N",
              item_kds_ready_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
              item_kds_serve_status: "N",
              item_kds_serve_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
              override_f: 0,
              is_addon_enable: "N",
              add_on_name: "",
              c_userid: "WEBORDER",
              c_date: moment().format("YYYY/MM/DD HH:mm:ss"),
              m_userid: "WEBORDER",
              m_date: moment().format("YYYY/MM/DD HH:mm:ss"),
              menu_type: "",
              modifier_name: "",
              ref_1: "",
              ref_2: "",
              ref_3: "",
              ref_4: "",
              new_table_no: null,
              select_item: false,
              combo_qty: 1,
              combo_price: price + "",
              combo_total: price + "",
              checked: false,
              remarks: cartItem.remarks,
              $$hashKey: "object:3888",
            });
            const addOnSales = cartItem.addOnValues.map((addOn, subIndex) => {
              return {
                s_no: sno++,
                ds_no: subIndex + 2,
                parent_sno,
                seat_no: 1,
                qty: addOn?.modifier_qty ?? 1,
                uom_cf: 1,
                disc_type: "N",
                disc_value: 0,
                disc_name: "None",
                disc_amt: 0,
                pro_disc_amt: 0,
                category_code: cartItem.item.category_code,
                item_no: addOn.item_no,
                item_name: addOn.citem_name,
                item_desc: addOn.citem_name,
                sku_no: addOn.sku_no,
                uom: addOn.uom,
                unit_price: addOn.price_dtls + "",
                price: addOn.price_dtls + "",
                sub_total:
                  addOn.price_dtls === 0
                    ? 0
                    : addOn.price_dtls * addOn.modifier_qty,
                svc_amt: isServiceCharge ? Number(serviceTax).toFixed(2) : 0,
                is_apply_svc: 1,
                tax_amt: Number(
                  cartItem?.item?.is_absorbtax
                    ? ((addOn.price_dtls * addOn.modifier_qty) /
                        (cartItem?.item?.tax_value + 100)) *
                        cartItem?.item?.tax_value
                    : (addOn.price_dtls * addOn.modifier_qty +
                        addOn.price_dtls *
                          addOn.modifier_qty *
                          totalServiceChange) *
                        (cartItem?.item?.tax_value / 100)
                ).toFixed(2),
                tax_rate: cartItem?.item?.is_absorbtax,
                tax_value: cartItem?.item?.tax_value,
                is_absorbtax: cartItem?.item?.is_absorbtax,
                take_away_item: dineOption === "dinein" ? "N" : "Y",
                order_seq: 1,
                order_seq_type: "New",
                order_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
                print_flag: "N",
                item_kds_ready_status: "N",
                item_kds_ready_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
                item_kds_serve_status: "N",
                item_kds_serve_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
                override_f: 0,
                is_addon_enable: "N",
                add_on_name: "",
                c_userid: "WEBORDER",
                c_date: moment().format("YYYY/MM/DD HH:mm:ss"),
                m_userid: "WEBORDER",
                m_date: moment().format("YYYY/MM/DD HH:mm:ss"),
                menu_type: "",
                modifier_name: addOn.modifier_name,
                ref_1: "",
                ref_2: "",
                ref_3: "",
                ref_4: "",
                new_table_no: null,
                select_item: false,
                combo_qty: 0,
                combo_price: 0,
                combo_total: 0,
                checked: false,
                remarks: "",
                $$hashKey: "object:3888",
              };
            });
            i = sno;
            salesDetails = [...salesDetails, ...addOnSales];
            qty--;
            parent_sno++;
          }
        } else {
          salesDetails.push({
            s_no: i++,
            ds_no: 1,
            parent_sno,
            seat_no: 1,
            qty: cartItem?.qty ?? 1,
            uom_cf: 1,
            disc_type: "N",
            disc_value: 0,
            disc_amt: 0,
            disc_name: "None",
            pro_disc_amt: 0,
            ...cartItem?.item,
            unit_price: price + "",
            price: price + "",
            sub_total: price === 0 ? 0 : price * cartItem?.qty,
            svc_amt: isServiceCharge ? Number(serviceTax)?.toFixed(2) : 0,
            is_apply_svc: 1,
            tax_amt: Number(
              cartItem?.item?.is_absorbtax
                ? ((price * cartItem.qty) / (cartItem?.item?.tax_value + 100)) *
                    cartItem?.item?.tax_value
                : (price * cartItem.qty +
                    price * cartItem.qty * totalServiceChange) *
                    (cartItem?.item?.tax_value / 100)
            ).toFixed(2),
            tax_rate: cartItem?.item?.is_absorbtax,
            tax_value: cartItem?.item?.tax_value,
            is_absorbtax: cartItem?.item?.is_absorbtax,
            take_away_item: dineOption === "dinein" ? "N" : "Y",
            order_seq: 1,
            order_seq_type: "New",
            order_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
            print_flag: "N",
            item_kds_ready_status: "N",
            item_kds_ready_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
            item_kds_serve_status: "N",
            item_kds_serve_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
            override_f: 0,
            is_addon_enable: "N",
            add_on_name: "",
            c_userid: "WEBORDER",
            c_date: moment().format("YYYY/MM/DD HH:mm:ss"),
            m_userid: "WEBORDER",
            m_date: moment().format("YYYY/MM/DD HH:mm:ss"),
            menu_type: "",
            modifier_name: "",
            ref_1: "",
            ref_2: "",
            ref_3: "",
            ref_4: "",
            new_table_no: null,
            select_item: false,
            combo_qty: 0,
            combo_price: 0,
            combo_total: 0,
            checked: false,
            remarks: "",
            $$hashKey: "object:3888",
          });
        }
      }
    );

    let orderMode = "";

    switch (type) {
      case "couter":
        orderMode = "PayAtCounter";
        break;

      case "card":
        orderMode = "PayFirst";
        break;

      case "qlubQR":
        orderMode = "PayLater";
        break;

      default:
        break;
    }

    const masterSubTotal = roundNumber(
      salesDetails?.reduce((a, b) => (a += Number(b?.sub_total)), 0)
    );
    const masterTaxTotal = roundNumber(
      salesDetails?.reduce((a, b) => (a += Number(b?.tax_amt)), 0)
    );
    const masterServiceChargeTotal = roundNumber(
      salesDetails?.reduce((a, b) => (a += Number(b?.svc_amt) || 0), 0)
    );
    let totalNetAmt = masterSubTotal + masterServiceChargeTotal;
    const isActualGSTInclusive =
      taxList?.filter((record) => record?.isGSTInclusive)?.length > 0;

    if (!isActualGSTInclusive) {
      totalNetAmt += masterTaxTotal;
    }

    const posPayload = {
      qr_code: localStorage.getItem(STORAGEKEY.QR_CODE),
      order_mode: orderMode,
      qr_type: config?.qr_type,
      comp_code: "01",
      store_name: localStorage.getItem(STORAGEKEY.STORE_NAME),
      doc_date: moment().format("YYYY/MM/DD HH:mm:ss"), // example 2021/01/01 00:00:00
      service_type: config?.is_quickservice
        ? "Q"
        : dineOption === "dinein"
        ? "E"
        : "T",
      service_type_info: dineOption === "dinein" ? "Dine In" : "Take Away",
      // localStorage.getItem("selectiDineOption") === "takeaway"
      //   ? "Takeaway"
      //   : "Dine In",
      order_status_id: config?.is_quickservice ? "P" : "C",
      order_status_desc: "New",
      kitchen_status_id: "P",
      kitchen_status_desc: "In Progress",
      sub_total: masterSubTotal,
      total_svc: masterServiceChargeTotal,
      total_tax: masterTaxTotal,
      net_amt: roundNumber(totalNetAmt),
      table_no: localStorage.getItem(STORAGEKEY.TABLE_NO),
      sales_service_dtls: [
        {
          service_name: "SERVICE CHARGE",
          service_by: "P",
          service_value: 10,
          sales_amt: Number(total).toFixed(2),
          service_amt: isServiceCharge ? serviceTax : 0,
        },
      ],
      sales_payment_dtls: [],
      sales_other_info: "",
      payment_register_name: config?.register_no,
      payment_shift_code: "SHIFT1",
      table_transfer: "N",
      c_date: moment().format("YYYY/MM/DD HH:mm:ss"),
      m_userid: "",
      m_date: moment().format("YYYY/MM/DD HH:mm:ss"),
      disc_type: "N",
      disc_value: 0,
      disc_amt: 0,
      total_disc: "0.00",
      round_adj_amt: "0.00",
      absorb_tax: isActualGSTInclusive ? "Y" : "N",
      register_name: config?.register_no,
      shift_code: "SHIFT1",
      absorb_tax_info: "",
      table_transfer_sno: "",
      sales_no: "",
      customer_code: "exempt",
      cust_addr_s_no: "",
      customer_name: "",
      card_no: "",
      dob: "",
      contact_no: "",
      email: "",
      address: "",
      postal_code: "",
      disc_name: "None",
      tips_amt: 0,
      total_tender_amt: "0.00",
      change_amt: 0,
      no_of_pax: 1,
      remarks: "",
      del_driver: "",
      ref_1:
        dineOption === "takeaway" && config?.is_quickservice
          ? orderTime === "now"
            ? "Collect Now"
            : "Collect Later"
          : "",
      ref_2: "",
      ref_3: "",
      ref_4:
        dineOption === "takeaway" && config?.is_quickservice
          ? orderTime === "now"
            ? ""
            : formatDate(new Date(orderTime))
          : "",
      ref_5: "",
      order_from: "TQR",
      c_userid: "",
      sales_dtls: salesDetails,
      //  Additional
      mode_of_order: dineOption === "dinein" ? "Dine In" : "Take Away",
      kitchen_remarks: "",
      delivery_datetime: "",
      pickup_datetime:
        dineOption !== "dinein"
          ? orderTime === "now"
            ? formatDate(new Date())
            : formatDate(new Date(orderTime))
          : "",
    };

    if (config?.is_quickservice) {
      posPayload.kds_status = "P";
    }

    const body = [];
    body.push(posPayload);

    console.log("body", body);
    try {
      const res = await PostSaleCreate(body);
      const result = res?.data?.data[0];

      await sendPosLog(result.sales_no, body?.[0]);

      if (result.result === "SUCCESS") {
        dispatcher(addSalesNo(result.sales_no));
        dispatcher(
          placeOrderSuccess({
            serviceTax,
            GSTTaxValue,
            order_status: "complete",
          })
        );
        setShowModal(false);
        setDisableButton(false);
        setIsLoading(false);

        if (usingOnlineLink) {
          const storeName = localStorage.getItem(STORAGEKEY.STORE_NAME);
          const tableNo = localStorage.getItem(STORAGEKEY.TABLE_NO);

          navigate("/payment-callback", {
            state: {
              redirectLink: `${process.env.REACT_APP_QLUB_PAYMENT}/?order_id=${result.sales_no}&restaurant_name=${storeName}&table_id=${tableNo}`,
            },
          });
        }
        return {
          success: true,
          message: result?.information,
        };
      } else {
        setIsErrorShow(true);
        setDisableButton(false);
        setErrorMessage(result?.information);
        setIsLoading(false);

        return {
          success: false,
          message: result?.information,
        };
      }
    } catch (err) {
      setDisableButton(false);
      setIsLoading(false);
      setIsErrorShow(true);
      setErrorMessage(
        err?.message || "POS error. Please place your order at the counter."
      );

      return {
        success: false,
        message:
          err?.message || "POS error. Please place your order at the counter.",
      };
    }
  };

  const deleteCart = (uuid) => {
    const findUuidList =
      formatPromotionCartData?.find((record) => record?.uuid === uuid)
        ?.uuidList || [];

    findUuidList?.forEach((record) => {
      dispatcher(deleteCartItem(record));
    });
  };
  const redirectHomepage = () => {
    navigate("/home");
  };

  const newTotal = useMemo(() => {
    let value = Number(total);

    if (isServiceCharge) {
      value += Number(serviceTax);
    }
    if (!taxList?.filter((record) => record?.isGSTInclusive)?.length) {
      value += taxList
        ?.filter((record) => !record?.isGSTInclusive)
        ?.reduce(
          (a, b) =>
            (a += b?.isGSTInclusive
              ? (total / (b?.taxAmt + 100)) * b?.taxAmt
              : (total + total * totalServiceChange) * (b?.taxAmt / 100)),
          0
        );
    }

    return value;
  }, [total, isServiceCharge, taxList, serviceTax, totalServiceChange]);

  const fetchSupabaseProducts = async () => {
    const resp = await getProducts(process.env.REACT_APP_MODE);
    if (!resp.error) {
      const hashedProducts = resp.data.reduce((result, item) => {
        result[item.pos_item_no] = {
          name: item?.name,
          dummyPrice: item?.dummy_price,
          description: item?.description,
          image_url: item?.image_url,
        };
        return result;
      }, {});
      setSupaProducts(hashedProducts);
      return hashedProducts;
    }
    return null;
  };

  const handleDispatchCartTax = useCallback(
    (data) => {
      dispatcher(setIsGSTInclusive(data?.is_absorbtax ? true : false));
      dispatcher(setIsServiceCharge(config?.hasServiceCharge ? true : false));
      dispatcher(
        setIsGST(data?.tax_name === "ZERO" || !data?.tax_name ? false : true)
      );
      dispatcher(setTaxValue(Number(data?.tax_value)));
    },
    [dispatcher]
  );

  useEffect(() => {
    fetchSupabaseProducts();
  }, []);

  useEffect(() => {
    if (formatPromotionCartData?.length > 0) {
      dispatcher(setTotal(formatPromotionCartData));
    }
  }, [formatPromotionCartData]);

  return (
    <>
      {isLoading && (
        <Spinner
          animation="border material-icons"
          className="loader-position z-3"
        />
      )}
      <div className="App">
        <div className="qr-before-body w-100">
          <Header title="Check Out" />
          <div
            style={{
              maxHeight: "calc(100svh - 40px)",
              height: "100svh",
              top: "40px",
            }}
            className="inner-div main-div position-absolute w-100">
            <div className="cart-divs position-fixed w-100">
              <div className="d-flex ps-4 pb-2 pe-3 pt-3 bg-white">
                <label className="recommendation-text">
                  RECOMMENDATIONS FOR YOU
                </label>
              </div>
              <div className="pt-2 bg-white pb-3 ps-2 pe-2">
                <Recommendation
                  responsive={responsive}
                  supaProducts={supaProducts}
                  // onDispatchCartTax={handleDispatchCartTax}
                />
              </div>
            </div>
            {formatPromotionCartData && formatPromotionCartData.length !== 0 ? (
              <>
                {/* <div
                  className="d-flex bg-white justify-content-between pt-2 ps-4 pb-2 pe-3"
                  style={{ marginTop: "300px" }}
                >
                  <div className="d-grid">
                    <label className="dine-option-text mb-1 text-uppercase">
                      {localStorage.getItem("selectiDineOption") === "takeaway"
                        ? "Takeaway"
                        : "Dine In"}
                    </label>
                    <label className="table-text mb-1 text-uppercase">
                      Table-{localStorage.getItem(STORAGEKEY.TABLE_NO)}
                    </label>
                  </div>
                  <div className="option-icon">
                    <span className="material-icons mt-3"> restaurant </span>
                  </div>
                </div> */}
                <div className="d-flex text-start flex-column ps-4 pb-2 pe-3 pt-3">
                  {/* if localStorage.getItem(STORAGEKEY.ORDER_TIME) === "now" then show current time + 15 mins else show the date time selected */}
                  <label
                    className="pickup-summary-text"
                    style={{ marginTop: "280px" }}>
                    PICKUP TIME :{" "}
                    {localStorage.getItem(STORAGEKEY.ORDER_TIME) === "now"
                      ? moment()
                          .add(15, "minutes")
                          .format("DD MMM YYYY, hh:mm A")
                      : localStorage.getItem(STORAGEKEY.ORDER_TIME)}
                  </label>
                  <span>
                    Please look out for your queue number on the receipt after
                    payment is completed
                  </span>
                </div>
                <div className="d-flex justify-content-between ps-4 pb-2 pe-3 pt-3">
                  <label className="order-summary-text">ORDER SUMMARY</label>
                  {/* <div onClick={redirectHomepage}>
                    <BsPlusLg className="font-22 me-2 material-icons" />
                    <label className="public-sans-font fw-normal font-16 line-height-20 material-icons">
                      ADD ITEM
                    </label>
                  </div> */}
                </div>
                {formatPromotionCartData &&
                  formatPromotionCartData.length > 0 &&
                  formatPromotionCartData.map((cartItem, index) => (
                    <Fragment key={index}>
                      <CartItem
                        cartItem={handleConvertPromotionCartItem(cartItem)}
                        setConfirmData={setConfirmData}
                        deleteCart={deleteCart}
                        placeOrder={placeOrder}
                        decrementCounter={decrementCounter}
                        incrementCounter={incrementCounter}
                        supaProducts={supaProducts}
                      />
                    </Fragment>
                  ))}

                <div className="d-flex  ps-4 pb-2 pe-3 pt-3">
                  <label className="payment-summart-text">
                    PAYMENT SUMMARY
                  </label>
                </div>
                <div className="bg-white d-flex justify-content-between p-4 text-start">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td className="sub-total-text pb-2">SUBTOTAL</td>
                        <td className="sub-total-text pb-2 text-end">
                          ${Number(total).toFixed(2)}
                        </td>
                      </tr>
                      {formatServiceChargeList?.map((record) => (
                        <tr key={record?.c_date}>
                          <td className="sub-total-text pb-2">
                            {record?.service_name} ({record?.service_value}%)
                          </td>
                          <td className="sub-total-text pb-2 text-end">
                            ${Number(record?.taxAmt * Number(total)).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                      {taxList?.map((record) => (
                        <tr>
                          <td className="sub-total-text pb-2">
                            {record?.taxName}
                          </td>
                          <td className="sub-total-text pb-2 text-end">
                            $
                            {Number(
                              record?.isGSTInclusive
                                ? (total / (record?.taxAmt + 100)) *
                                    record?.taxAmt
                                : (total + total * totalServiceChange) *
                                    (record?.taxAmt / 100)
                            ).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={2}>
                          <hr className="dashed-border" />
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="public-sans-font fw-bold font-16 black-text line-height-21 pb-2 pt-2">
                          TOTAL
                        </td>
                        <td className="public-sans-font fw-bold font-16 black-text line-height-21 pb-2 pt-2 text-end">
                          $
                          {(
                            Number(total) +
                            Number(serviceTax) +
                            Number(GSTTaxValue)
                          ).toFixed(2)}
                        </td>
                      </tr> */}
                      {/* <tr>
                        <td
                          colSpan={2}
                          className="public-sans-font fw-normal font-16 black-text line-height-17 pt-2"
                        >
                          If you continue, you accept our{" "}
                          <Link
                            to="/profile"
                            className="privact-txt text-decoration-underline"
                          >
                            Privacy Policy
                          </Link>{" "}
                          and our{" "}
                          <Link
                            to="/profile"
                            className="privact-txt text-decoration-underline"
                          >
                            {" "}
                            Terms of Services
                          </Link>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>

                <div style={{ flex: 1 }}></div>

                <div className="position-sticky set-width bottom-0 bg-white cart-button-div pt-1 pb-1 ps-3 pe-3">
                  {isErrorShow && (
                    <p className="error-text text-danger text-start mb-2">
                      {errorMessage}
                    </p>
                  )}

                  {/* <Button
                    className="fill-green-btn cart-btn mt-2 public-sans-font fw-bold font-16 line-height-21 letter-spacing-02"
                    type="submit"
                    onClick={() => setShowModal(true)}
                  >
                    Place Order
                  </Button> */}

                  <button
                    onClick={() => setShowModal(true)}
                    className="w-100 fill-btn mb-2 mt-1 me-4">
                    <div className="d-flex align-items-center justify-content-between w-100 text-white">
                      <span className="place-order-text">Proceed to pay</span>
                      <span className="place-order-text">
                        Items: {cartItemsCount}
                      </span>
                      <span className="place-order-text rounded-circle me-2 px-2 py-1">
                        $
                        {handleConvertPromotionTotal(
                          Number(newTotal),
                          Number(total)
                        ).toFixed(2)}
                      </span>
                    </div>
                  </button>

                  <ConfirmationModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    setDisableButton={setDisableButton}
                    disableButton={disableButton}
                    paymentpage={paymentpage}
                  />
                </div>
              </>
            ) : (
              <div style={{ marginTop: "300px", height: "60vh" }}>
                <img
                  src={`/assets/commonImages/${config?.EmptyImage}.png`}
                  alt="empty Screen"
                  className="mt-5 pt-4"
                />
                <div className="d-grid mt-3 me-3 ms-3">
                  <label className="empty-cart-text mb-1 text-uppercase">
                    Your Cart is Empty
                  </label>
                  {/* <label className="public-sans-font fw-bold font-16 black-text line-height-20 ms-3 me-3 text-uppercase">
                    Looks like you haven't made your choice yet
                  </label> */}
                </div>
                <Button
                  className="fill-btn menu-btn w-50 mt-4"
                  type="submit"
                  onClick={redirectHomepage}>
                  Explore our Menu
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      {showModalOpen ? (
        <CustomizeModal
          showModal={showModalOpen}
          setShowModal={setShowModalOpen}
          showModalData={showModalData}
        />
      ) : (
        ""
      )}
      <ConfirmModal
        open={confirmData?.open}
        title={confirmData?.title}
        description={confirmData?.description}
        onConfirm={confirmData?.onConfirm}
        onCancel={() => setConfirmData({})}
      />
    </>
  );
}
export default Cart;
